import { useContext } from 'react';
import { BIMContext } from 'providers/bim-provider';
import { ContentWrapper, Textarea, Textbox, SelectMenu } from 'components/generic';
import { bimFileType } from 'config';
import { getValuesById } from 'utils';
import './style.scss';

const GeneralDetails = props => {
	const context = useContext(BIMContext);
	const { createObj, dockerState, setCreateObj, errorMsgLoadCode } = context;

	// data handler to create obj
	const dataHandler = (e, key) => {
		setCreateObj(prevState => ({ ...prevState, [key]: e }));
	};

	return (
		<>
			<ContentWrapper shadow>
				<div className='row'>
					<div className='col-6'>
						<Textbox
							infoContent='Enter Mapping Name'
							label='Mapping Name'
							placeholder='ADD INFO'
							error={errorMsgLoadCode}
							errorMessage={errorMsgLoadCode}
							value={createObj?.bfm_loadCode}
							mandatory
							onChange={e => dataHandler(e?.target?.value, 'bfm_loadCode')}
							onBlur={e => props.checkLoadCode(e?.target?.value)}
							disabled={dockerState === 'view' || dockerState === 'edit'}
						/>
					</div>
				</div>
				<div className='row'>
					<div className='col-6'>
						<Textarea
							infoContent='Enter Mapping Description'
							label='Mapping Description'
							placeholder='Additional Fields for Customer Information'
							value={createObj?.bfm_description}
							mandatory
							onChange={e => dataHandler(e?.target?.value, 'bfm_description')}
							disabled={dockerState === 'view'}
						/>
					</div>
				</div>
				<div className='row'>
					<div className='col-6'>
						<SelectMenu
							infoContent='Select File Type'
							label='File Type'
							menuOptions={bimFileType}
							placeholder='Delimiter Seperated'
							mandatory
							value={getValuesById(bimFileType, createObj.bfm_fileType)}
							onChange={e => dataHandler(e, 'bfm_fileType')}
							disabled={dockerState === 'view' || dockerState === 'edit'}
						/>
					</div>
				</div>
			</ContentWrapper>
		</>
	);
};

export default GeneralDetails;
